import { combineReducers } from 'redux'
import Crate from 'crate-core'
const store = require('store')

let config = {}
// check if there is no id create random Id
if (!store.get('config')) {
  config.id = Crate.getRandomId()
  config.pseudo = Crate.Marker.getPseudoname(config.id)
  config.signalingServer = 'https://carteserver.herokuapp.com'
  config.storageServer = 'https://storagecrate.herokuapp.com'
  config.ICEsURL = 'https://carteserver.herokuapp.com/ice'
  config.stunTurn = '23.21.150.121'
  store.set('config', config)
}

const initialState = {
  configuration: store.get('config')
}

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'CONFIG':
      return {
        ...state,
        configuration: { ...state.configuration, ...action.payload }
      }
    default:
      return state
  }
}

export default rootReducer
